import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "svg-icon-mcbannerTypeShape",
  "use": "svg-icon-mcbannerTypeShape-usage",
  "viewBox": "0 0 16 16",
  "content": "<symbol viewBox=\"0 0 16 16\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\" id=\"svg-icon-mcbannerTypeShape\"><path fill-rule=\"evenodd\" clip-rule=\"evenodd\" d=\"M12 2H4v10l6-5 2 1.667V2zm2-.001v-2H2V16h12V1.999zM7.5 5a1.5 1.5 0 1 0-3.001.001A1.5 1.5 0 0 0 7.5 5z\" fill=\"#000\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol